module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "4screenshot.c2043cf9.svg";